module.exports = __webpack_public_path__ + "img/ja.dee6d3ef.svg";